import styled from "styled-components";
import React, { memo } from "react";
import msToTime from "astrid-helpers/src/msToTime";
import useMouse from "astrid-hooks/src/useMouse";
import Cursor from "./Cursor";
import { useCursor } from "./state/cursor";
import { useDuration } from "./state/duration";
import { useOffset } from "./state/offset";
import { useRect } from "./state/rect";
import { useRipple } from "./state/ripple";
import { useSize } from "./state/size";
const Root = /*#__PURE__*/styled(Cursor).withConfig({
  displayName: "Root",
  componentId: "sc-1vihtcq-0"
})(["pointer-events:none;"]);
const MouseCursor = /*#__PURE__*/memo(() => {
  const rect = useRect();
  const size = useSize();
  const offset = useOffset();
  const ripple = useRipple();
  const cursor = useCursor();
  const duration = useDuration();
  const {
    x,
    y
  } = useMouse(rect);
  if (!cursor || ripple || y < 0 || y > rect.height + 40) return false;
  const x1 = x / rect.width;
  const position = offset + x1 * size;
  return /*#__PURE__*/React.createElement(Root, {
    position: position,
    color: "default",
    align: x1 > 0.94 ? "left" : "right"
  }, msToTime(y < rect.height ? position : x1 * duration));
});
export default MouseCursor;
//# sourceMappingURL=MouseCursor.js.map